module.exports = __webpack_public_path__ + "static/media/buscar-logo-light-2.5de34384.png";